// Fixed top-of-screen warning shown when the live Firestore listeners
// have errored out (see shared/lib/connectionStatus.ts + db.ts). It tells
// the user their data may be stale and offers a one-tap reload, instead
// of leaving them staring at frozen data that looks current.
import { useSyncExternalStore } from 'react'
import {
  getConnectionHasError,
  subscribeConnectionStatus,
} from '../lib/connectionStatus'

export default function ConnectionBanner() {
  const hasError = useSyncExternalStore(
    subscribeConnectionStatus,
    getConnectionHasError,
    getConnectionHasError,
  )

  if (!hasError) return null

  return (
    <div
      role="alert"
      className="no-print fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950 shadow-md"
    >
      <ion-icon name="cloud-offline-outline" style={{ fontSize: 18 }}></ion-icon>
      <span>Connection lost — data may be out of date.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-md bg-amber-950/10 px-3 py-1 font-semibold text-amber-950 transition-colors hover:bg-amber-950/20"
      >
        Reload
      </button>
    </div>
  )
}
